module.exports = __webpack_public_path__ + "img/u21.a9b75e25.png";